import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getStudent } from "../../features/slices/studentManagementReducer";
import { useSelector } from "react-redux";
import Select from "react-select";
import { addNotifications, editNotifications } from "../../features/slices/notification";
import { toastService } from "../../utils/toastify";
import { useLocation, useNavigate } from "react-router-dom";
const initialState = {
  userType: "",
  userId: "",
  title: "",
  content: "",
  defaultOption:"",
};
const EditNotification = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [userOptions, setUserOptions] = useState([]);
  const { userType, userId, title, content, defaultOption } = iState;
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const {state}=useLocation()
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({ ...prev, [name]: value }));
  };
  const { studentData } = useSelector((state) => {
    return state?.student;
  });

  useEffect(() => {
    dispatch(getStudent({ limit: 10000 }));
    setUpdateState((prev) => ({
      ...prev,
      userType: state?.userType,
      userId: state?.userType == "Single" && state?.users?.[0],
      title: state?.title,
      content: state?.content,
      defaultOption: userOptions.find(
        (option) => option.value === state?.users?.[0]
      ),
    }));
  }, []);
  const handleSendNotification = () => {
    const data = {
      title,
      content,
      userType,
      ...(userType === "Single" && { userId }),
      sendStatus: "SEND",
      id:state?._id,
    };
    dispatch(editNotifications(data)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Notification sent successfully");
        navigate("/notification");
      } else {
        toastService.error("Notification sent Failed");
      }
    });
  };
useEffect(() => {
  const Options = studentData?.result?.[0]?.paginationData?.map((item) => ({
    label: item.fullName,
    value: item._id,
  }));
  setUserOptions(Options);
  const defaultOption = Options?.find(
    (option) => option.value === state?.users?.[0]
  );

  setUpdateState((prev) => ({
    ...prev,
    defaultOption, 
  }));
}, [studentData]);
  const handleChangeOption = (selectedOption) => {
    setUpdateState((prevState) => ({
      ...prevState,
      userId: selectedOption ? selectedOption.value : null, // If no option is selected, set to null
    }));
  };

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit Message</h4>
          </div>
          <div className="CommonForm CommonFormListType">
            <div className="d-flex justify-content-between align-items-end">
              <div className="form-group w-100">
                <label>User Type</label>
                <select
                  className="form-control"
                  name="userType"
                  value={userType}
                  onChange={handleChange}
                >
                  <option>select</option>
                  <option value="All">All</option>
                  <option value="Single">Single</option>
                </select>
              </div>
              <div className="form-group mx-4">
                <label>Or</label>
              </div>
              <div className="form-group w-100">
                <label>Search User</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  value={defaultOption} 
                  isClearable={true}
                  name="userId"
                  options={userOptions}
                  onChange={handleChangeOption}
                />
              </div>
            </div>
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Add Title"
                name="title"
                value={title}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Messages</label>
              <textarea
                className="form-control"
                placeholder="Write here..."
                rows={5}
                defaultValue={""}
                name="content"
                value={content}
                onChange={handleChange}
              />
            </div>
            {/* <div className="form-group">
              <ul className="SocialCheck">
                <li>
                  <label className="CheckBox">
                    {" "}
                    WhatsApp
                    <input type="checkbox" />
                    <span className="checkmark" />
                  </label>
                </li>
                <li>
                  <label className="CheckBox">
                    {" "}
                    SMS
                    <input type="checkbox" />
                    <span className="checkmark" />
                  </label>
                </li>
                <li>
                  <label className="CheckBox">
                    {" "}
                    Email
                    <input type="checkbox" />
                    <span className="checkmark" />
                  </label>
                </li>
                <li>
                  <label className="CheckBox">
                    {" "}
                    Web Notification
                    <input type="checkbox" />
                    <span className="checkmark" />
                  </label>
                </li>
              </ul>
            </div> */}
            <div className="form-group">
              <button className="Button" onClick={handleSendNotification}>
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditNotification;
